import React from "react";
import {
    ContentWrapper,
    ProductOrderLinkedTitle,
    ProductOrderLinkedWrapper,
} from "../Styled";
import { StyledNavLink } from "../../../../shared/styled/TableStyles";
import { ProductOrder } from "../../../../data/entities";
import { ProductTableText } from "../../../ProductOrder/single/Styled";

interface ProductOrderLinkProps {
    productOrder: ProductOrder;
}

export const ProductOrderLink = ({ productOrder }: ProductOrderLinkProps) => {
    return (
        <ContentWrapper>
            <ProductTableText>Thông tin đơn hàng sản phẩm</ProductTableText>
            <ProductOrderLinkedWrapper>
                <>
                    <ProductOrderLinkedTitle>
                        Mã đơn hàng sản phẩm:
                    </ProductOrderLinkedTitle>
                    <StyledNavLink to={`/product-orders/${productOrder.id}`}>
                        {productOrder.name}
                    </StyledNavLink>
                </>
            </ProductOrderLinkedWrapper>
        </ContentWrapper>
    );
};
